<template>
	<div class="movie-hall page">
		<van-nav-bar class="nav-bar" :title="$t('直播间')" />
		<div class="live-scroll">
			<div class="live-item" v-for="(v,key) in listdata" :key="key">
				<div>
					<div class="avatar-div">
						<img :src="v.imgurl" alt="" class="avatar-img">
						<img src="data:image/gif;base64,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" alt="" class="live-img">
					</div>
					<ul>
						<li>{{v.name}}</li>
						<li>{{ $t('官方认证女神') }}</li>
						<li>{{ $t("已缴纳20000保证金") }}</li>
						<li>{{ $t('地区') }}:{{v.area}}</li>
					</ul>
				</div>
				<div>
					<div class="video-img-div" @click="goliveVideo(v.videourl)">
						<img :src="v.imgurl" alt="">
						<span class="play">
							<b></b>
						</span>
					</div>
					<ul>
						<li>{{ $t('签名') }}:{{v.signature}}</li>
						<li>
							<div v-for="label in v.label" :key="label">{{label}}</div>
						</li>
						<li @click="lianxi()">
							<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAYAAADFniADAAACe0lEQVRYhcWYO2gUURSGv9UgklgkpNVCW0EkWqlEJdiohYipIyJYaaPYWgmKvQ9sDCgkWFhpaWMrpNDKBCzUzhdoEDXml5ud0cmcM3deu9kf/i3OPffsN2fuzt47HUkMWCPAD2A1xdg0QJ69wAvgG/AJuAx01kZCpwbgSUnfZXU1sAzi9k0Cz5Lbllfo2vhGQ8WAUo1t5JqqArQAfPXW04SkESfexkVrKKufkg6t3bncF91IklYkvZY0K+mSpIMtQKsCnUznZCffNKnrlYI+kHRR0gFJww5EK6As1GZJ5yW9NVPiCqCvCkAbAXm3b0tDuKxS0EZAHlQv4WIqBIpB9RMuClQFqtdwpUB1oHoBF4BOODWNTaBPcJWB2kClPibpj0HwgYYkbXVqGJtADR+RtGwQioEeSzraT6gmQEFXnFrGJtBHoKA5p56xCZS4DVDQm5L6taHaAgWtShp1aq/zUGaDNQ1cA95n/A74AGwDZoFhsy37r1/AaeApcAo4YzK6B4MJ4LkZySohnJb021xXdeWfQ6FTSwWzSxd7+BiTtGCmNgdKfdZkdjXv5Bqo1FOSniRbjzpAx73CkW4tOrmFUKl3Srol6bMpVx0o1q3SxW4CGYc9+YVkw+ZpxpnjdWvRmTvl5P5z7Ii1DNwD9iRHn7y+mIjVCnDdRLu/wELFoFKF0+ptE4XtJuLrIbCUG9nvZiaqehh9BHxsCOV1a5/JagAVXtXcz8V2mKxi5bu1Cxgtyq5zbL+bXHUTqHy3wpN9t8lK5a3+iOfrPG8iv8Q7kjpOTu0/5ODDSdGw2zznjJd5pgyoCVTwy4ZAweEkHgUKbvJ+ajx5HdgfAX8Bb09sLMgJwiYAAAAASUVORK5CYII=" alt="">
							<span>{{ $t('获取联系方式') }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Dialog } from 'vant';
export default {
	data() {
		return {
			listdata:[]
		};
	},
	methods: {
		goliveVideo(videourl) {
		  this.$router.push({ path: "/livevideo?videourl="+encodeURIComponent(videourl) });
		},
		lianxi() {
		  Dialog.alert({
		    title: this.$t('温馨提示'),
		    message:
		      this.$t('联系数据老师激活权限'),
		    theme: "round-button",
		    width: "310px",
		    confirmButtonText: this.$t('联系专属接待客服'),
		    confirmButtonColor: "#efcba7",
		    getContainer: ".live-scroll",
		  }).then(() => {
		    Dialog.close;
		  });
		},
		getlistdata(){
			this.$http({
				method: 'get',
				url: 'zhibojianlist'
			}).then(res => {
				this.listdata = res.data;
			});
		}
	},
	created() {
		this.getlistdata();
	}
};
</script>

<style lang="less" scoped>
.page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
	background-color: #16151b;
	height: 100%;
}
.nav-bar {
	/* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
	height: 100px;
	background-color: #16151b;
}
.van-nav-bar {
	line-height: 50px;
}

::v-deep .van-nav-bar__title {
	max-width: 60%;
	margin: 0 auto;
	color: #f3c7a2;
	font-size: 35px;
}
::v-deep .van-nav-bar__content {
	height: 100px;
}
.live-scroll {
	// display: flex;
	// align-items: center;
	height: calc(100% - 15px);
	width: calc(100% - 30px);
	margin: 0 auto;
	overflow-y: auto;
	margin-bottom: 3.75rem;
}
.live-item {
	width: 100%;
	background: linear-gradient(120deg, #212121, #313131);
	border-radius: 0.625rem;
	margin-bottom: 0.625rem;
}
.live-item>div:first-child {
    height: 5.875rem;
    margin-bottom: 1.13333rem;
}
.live-item>div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.live-item>div:nth-child(2) {
    height: 11.6875rem;
}
.live-item>div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.live-item>div:first-child .avatar-div {
    width: 5.8125rem;
    margin: 0 .53333rem;
    position: relative;
}
.live-item>div>div {
    display: flex;
    align-items: center;
    justify-content: center;
}
.live-item>div {
    height: 100%;
}
.live-item>div:first-child .avatar-div .avatar-img {
    width: 4.875rem;
    height: 4.875rem;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 50%;
}
.live-item>div:first-child .avatar-div .live-img {
    width: 1.3125rem;
    position: absolute;
    right: -.26667rem;
    top: calc(50% + .13333rem);
}
.live-item>div:first-child>ul {
    width: 15.625rem;
}
.live-item>div>ul {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: .13333rem;
}
.live-item>div:first-child>ul>li:first-child {
    position: relative;
}
.live-item>div:first-child>ul>li {
    font-size: 0.9375rem;
    font-weight: 700;
    color: #fff;
}
.live-item>div>ul>li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.live-item>div:first-child>ul>li:first-child:before {
    content: "";
    display: inline-block;
    width: 1.3125rem;
    height: 1.125rem;
    border-radius: .08rem;
    background: #e5338b;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABmklEQVQ4jZWUPShGYRTH/6+PwUdJkqR8lAFlJEmZLWIzGJmURZmYGJiUYrJTysckg8SkDEgkA1GEQryDFH56dN56vPd5r9epM9zz8bvnnHvOTQDKUkokVUpKSrqX9BFMc8AYLQBGgAN+ywuwCLSm58bBGoBzw7wCa8AMsAAcmv0TmAASfwHrgQdLmASKAzFtwLGBZ+OAecAR8AX0Bfy+uhftGbQnE7Av/a1/aDXwBpy61kPBK9ZqVcCXSResiJacyGeX2iWdSLqJeDLLpnmCwApJtxFrvNyZtyQEfJZUHrHGS5l5n0LAfUnNkkojnszSaZ6z0JAHbcBjAV9IS4En4MatXCqgA5gDiuzcLoB3oD0A8DUXWLcCBv09HDbjrkGn7DkJ9Pun5anbvw2LW03FpAISViG2oO5KroBHzzYNDAGjwLIts5Ml6ypyeg665R19E1AJzNvPIV3cefamV+8DB6yypCXuWPvOl++uAOgGuoCawAh+AVOwS6DOa3/bBp/tCf4AGz1Yrde++zlcA4X/BbqBjttXyzoxqKBvZFvitzhRgooAAAAASUVORK5CYII=");
    background-size: 70%;
    background-position: 40%;
    background-repeat: no-repeat;
    position: absolute;
    left: 50%;
    top: .02rem;
}
.live-item>div:first-child>ul>li:nth-child(2) {
    color: #7ef0f4;
}
.live-item>div:first-child>ul>li:nth-child(3) {
    color: #e86272;
}
.live-item>div:nth-child(2) .video-img-div {
    position: relative;
}
.live-item>div:nth-child(2) .video-img-div img {
    width: 8.25rem;
    height: 10.6875rem;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 0.625rem;
}
.live-item>div:nth-child(2) .video-img-div .play {
    position: absolute;
    top: calc(50% - 1.5625rem);
    left: calc(50% - 1.5625rem);
    width: 2.3125rem;
    height: 2.3125rem;
    line-height: .4rem;
    border-radius: 50%;
    background-color: rgba(0,0,0,.3215686274509804);
}
.live-item>div:nth-child(2) .video-img-div .play b {
    content: "";
    display: inline-block;
    position: absolute;
    top: 1.18rem;
    left: 1.66667rem;
    transform: translate(-50%,-50%);
    height: 0;
    width: 0;
    border-style: solid;
    border-width: 0.625rem;
    border-color: transparent transparent transparent #fff;
    vertical-align: middle;
    margin-top: .02rem;
}
.live-item>div:nth-child(2)>ul {
    width: 13.9375rem;
	padding-left: 0.625rem;
	height: 100%;
}
.live-item>div>ul {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: .13333rem;
}
.live-item>div:nth-child(2)>ul>li:first-child {
    font-size: 0.8125rem;
    color: silver;
    margin-bottom: .13333rem;
}
.live-item>div:nth-child(2)>ul>li:nth-child(2) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.live-item>div:nth-child(2)>ul>li {
    color: #fff;
}
.live-item>div:nth-child(2)>ul>li:nth-child(3) {
    width: 10.375rem;
    height: 1.6875rem;
    margin-top: .26667rem;
    text-align: center;
    border-radius: 1.6875rem;
    background-image: linear-gradient(90deg,#e34c6f,#ef9163);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.live-item>div:nth-child(2)>ul>li:nth-child(3) img {
    height: 1rem;
    margin-right: .13333rem;
}
.live-item>div:nth-child(2)>ul>li:nth-child(3) span {
    font-size: 0.9375rem;
}
.live-item>div:nth-child(2)>ul>li:nth-child(2)>div:first-child {
    background-color: #e9335d;
}
.live-item>div:nth-child(2)>ul>li:nth-child(2)>div:nth-child(2) {
    background-color: #d14a42;
}
.live-item>div:nth-child(2)>ul>li:nth-child(2)>div:nth-child(3) {
    background-color: #285ab7;
}
.live-item>div:nth-child(2)>ul>li:nth-child(2)>div:nth-child(4) {
    background-color: #eb46b9;
}
.live-item>div:nth-child(2)>ul>li:nth-child(2)>div {
    height: 1.25rem;
    padding: 0 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1.125rem;
    margin: 0.625rem 0.625rem 0.3125rem 0;
	font-size: 0.34667rem;
}
::v-deep .van-dialog {
  background-color: #262626;
  height: 10.25rem;
}
::v-deep .van-dialog__header {
  color: #e6b98a;
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 0.625rem;
}
::v-deep .van-dialog__message {
  width: 80%;
  line-height: 1.25rem;
  margin: 30px auto;
  font-size: 0.9375rem;
  color: #fff;
}
::v-deep .van-dialog__footer {
  background-color: #262626;
  width: 12.5rem;
  margin: 0 auto;
}
::v-deep .van-dialog__confirm {
  background: linear-gradient(180deg, #efcba7, #dcab76);
  font-size: 0.9375rem;
  width: 12.5rem;
  height: 1.5625rem;
}
::v-deep .van-button__text {
  color: #8a5623;
}
</style>
